<form [formGroup]="form" autocomplete="off" class="form-horizontal">

  <div class="form-row mb-0x">
    <label class="col-sm-8 col-form-label"
           for="laufendeNummer{{index}}">{{ 'COMMON_UI.FRAGEBOGEN.ANTEILSEIGNER.LAUFENDE_NUMMER' | translate }}</label>

    <div class="col-sm-4">
      <input class="form-control" datevMessagePath="laufendeNummer{{objectId}}" formControlName="laufendeNummer" id="laufendeNummer{{index}}"
             type="text" utilsCheckValidity
             utilsControlState utilsMarkRequired utilsValidationMessage/>
    </div>
  </div>

</form>
